import { useMgmtFeeContext } from 'context/MgmtFeeContext';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import MgmtFeeBanner from 'views/shared/MgmtFeePolicyEnforcer/mgmtFeeBanner';
import { MgmtViewsEnum } from 'views/shared/types';

const CombineFeeBanner = () => {
  const { t } = useTranslation();
  const { enforceMgmtFeeRules } = useFlags();
  const {
    state: { showBanner },
    updateState,
  } = useMgmtFeeContext();

  if (!showBanner || !enforceMgmtFeeRules) return null;

  return (
    <MgmtFeeBanner
      title={
        <h3 className="text-md font-medium dark:text-white mb-3">
          {' '}
          {t('account:feePolicyEnforcerTemplate.banner.title')}
        </h3>
      }
      onOpen={() => updateState({ showModal: true, viewType: MgmtViewsEnum.COMBINE_FEE_TYPE })}
      subTitle={null}
    />
  );
};

export default CombineFeeBanner;
